export const trimWhitespacesAndQuotes = (str: string): string => {
  return str.replace(/^['"]+|['"]+$/g, "").trim();
};
